<template>
  <div :class="['sys-notice-meta', mode ? `sys-notice-meta-${mode}`: '']">
    <UserAvatar class="meta-avatar" :user-avatar="avatarSrc" />
    <div class="meta-body-conatiner">
      <span :class="['meta-body', 'text-black', mode ? '' : 'line-clamp-text']">
        <span class="title">{{meta.title}}：</span><span class="info">{{meta.info}}</span>
      </span>
    </div>
  </div>
</template>
<script>
import UserAvatar from '@/components/business/avatar/UserAvatar.vue'
import avatar from '@/assets/sys-notice.png'
export default {
  name: 'SysNoticeMeta',
  props: {
    meta: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      default(){ return '' }
    }
  },
  components: {
    UserAvatar
  },
  computed: {
    avatarSrc () {
      return avatar
    }
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
@import url(./meta.less);
.sys-notice-meta {
  .meta(2);
  .meta-body-conatiner{
    height: 48px;
    line-height: 24px;
    display: flex;
    align-items: center;
  }
  .meta-body {
    height: auto;
    padding-right:32px;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    .title{
      color: #333333;
    }
    .info{
      color: #999B9F;
    }
  }
  &.sys-notice-meta-custom{
    padding: 12px 0;
    align-items: stretch;
    .meta-body-conatiner{
      height: auto;
    }
    .meta-body{
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
      .info{
        color: #333333;
      }
    }
  }
}
</style>
